/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
    IAgentPlugin,
    IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { TRACK_HISTORY } from "../graphql/getTrackHistory.query";
import { VApplication } from "../../../application";
import moment from "moment";

const is = require("is_js");

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IGetTrackHistoryMethods extends IPluginMethodMap {
    getTrackHistory(args: any): Promise<any>;
}

export class GetTrackHistoryService implements IAgentPlugin {
    readonly methods: IGetTrackHistoryMethods;

    constructor() {
        this.methods = {
            getTrackHistory: this.getTrackHistory.bind(this),
        };
    }

    async getTrackHistory(args: any) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        console.log("filet apply====", args);
        let variables = {
            filters: {
                _id: args?.id
            },
        };
        console.log("filter in track history", variables);
        try {
            if (client) {
                const res = await client.query({
                    query: TRACK_HISTORY,
                    variables: variables,
                    fetchPolicy: "network-only",
                });
                return res
            }
        } catch (err: any) {
            let _display_message =
                err?.graphQLErrors &&
                Array.isArray(err?.graphQLErrors) &&
                err?.graphQLErrors.find((item: any) => item.extensions);
            if (_display_message?.extensions?.display_message) {
                throw Error(_display_message?.extensions?.display_message);
            }

            throw err;
        }
    }

}
